// Handle swatch selection on the product page
document.addEventListener("click", (e) => {
  // Only target swatch inputs within variant-picker that are color options
  const swatch = e.target.closest(
    'variant-picker .m-product-option--swatch .m-product-option--node__label[data-option-type="color"]'
  );
  if (!swatch) return;

  // Find all swatches in this color option group and remove selected class
  const optionGroup = swatch.closest(".m-product-option--swatch");
  optionGroup
    .querySelectorAll(
      '.m-product-option--node__label[data-option-type="color"]'
    )
    .forEach((s) => {
      s.classList.remove("is-selected");
    });

  // Add selected class to clicked swatch if its radio input is checked
  const input = swatch.previousElementSibling;
  if (input && input.checked) {
    swatch.classList.add("is-selected");
  }
});

// Listen for changes on the variant picker to update selected states
document.addEventListener("change", (e) => {
  if (!e.target.matches('variant-picker input[type="radio"]')) return;

  // Find all color swatches in the variant picker
  const variantPicker = e.target.closest("variant-picker");
  if (!variantPicker) return;

  // Update selected state for all color swatches
  variantPicker
    .querySelectorAll(
      '.m-product-option--swatch .m-product-option--node__label[data-option-type="color"]'
    )
    .forEach((swatch) => {
      const input = swatch.previousElementSibling;
      swatch.classList.toggle("is-selected", input && input.checked);
    });
});

// Set initial selected state based on variant-color data-selected-value
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("variant-color").forEach((variantColor) => {
    const selectedValue = variantColor.getAttribute("data-selected-value");
    if (!selectedValue) return;

    const selectedSwatch = variantColor.querySelector(
      `.m-product-option--node[data-value="${selectedValue}"] .m-product-option--node__label`
    );
    if (selectedSwatch) {
      selectedSwatch.classList.add("is-selected");
    }
  });
});
